import React, { useState } from 'react';

// import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import s from './EventSubmission.module.scss';
import ButtonPrimary from '../ButtonPrimary/ButtonPrimary';
import ButtonPrimaryEllipse from '../ButtonPrimaryEllipse';

const EventSubmission = ({ buttonText, title, text, href = '/' }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div className={s.Root}>
      <div className={s.Container}>
        <a
          href={href}
          className={`${s.Content} black-glass`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}>
          <div className={s.TextWrapper}>
            <h3 className={s.Title}>{title}</h3>
            <p className={s.Description}>{text}</p>
          </div>
          <div className={s.ButtonWrapper}>
            <span className={s.MobileText}>{buttonText}</span>
            <ButtonPrimaryEllipse
              isHovered={isHovered}
              animateIcon
              size="large"
              modifiers={['InlineFlex', 'LargeOnlyIcon', 'PurpleBlue']}
              icon="icon-arrow-right-white"
            />
          </div>
        </a>
      </div>
    </div>
  );
};
EventSubmission.propTypes = {};

export default EventSubmission;
